/**
 * Created by Alex Xia on 11/20/2020.
 * Description:
 * ------ maintenance history ------
 */

export enum MapTripActionType {
    closeTripPanel,
    refreshTripDirections
}

export enum MapTripVehicleType {
    driving = 'DRIVING',
    transit = 'TRANSIT',
    walking = 'WALKING'
}
